// extracted by mini-css-extract-plugin
export var button = "_ri-0";